module.exports = __webpack_public_path__ + "static/media/S1N4-3.9f82e18c.svg";